import { GamesWithCategories } from 'containers/GamesBlock/types'

import { useGamesWithCategories } from './useGamesWithCategories'

export default function useCategories() {
  return useGamesWithCategories({ select: ({ categories }: GamesWithCategories) => categories })
}
